import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "items-center" }
const _hoisted_2 = { class: "text-left font-semibold text-neutral-900" }
const _hoisted_3 = { class: "text-left text-sm text-gray-600" }
const _hoisted_4 = { class: "space-y-6 text-left" }
const _hoisted_5 = { class: "flex justify-end items-center space-x-3" }

import BaseModal from '@/components/modals/BaseModal.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ContentModal',
  props: {
    show: {
        type: Boolean
    },
    title: {
        type: String,
        default: 'Fetch from existing data',
    },
    description: {
        type: String,
        default: 'Relevant data and other details',
    },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    customClass: "p-6 w-[480px] space-y-6 !overflow-visible",
    show: __props.show
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(__props.title), 1),
        _createElementVNode("p", _hoisted_3, _toDisplayString(__props.description), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _createElementVNode("div", _hoisted_5, [
        _renderSlot(_ctx.$slots, "button")
      ])
    ]),
    _: 3
  }, 8, ["show"]))
}
}

})